<template>
    <div>
        <div class="knowlegdebank-header">
            <div class="grid-container">
                <!-- <div v-html="breadcrumb" class="knowlegdebank-header__breadcrumb"></div> -->
                <div class="knowlegdebank-header__container">
                    <div class="knowlegdebank-header__image">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 624.7 632.8" fill="#005989"
                             xmlns:v="https://vecta.io/nano">
                            <path d="M9 313c.1 80 31.9 156.7 88.4 213.2 56.6 56.5 133.2 88.3 213.2 88.4 79.9-.1 156.6-31.9 213.1-88.5C580.2 469.6 611.9 393 612 313c-.1-79.9-31.9-156.5-88.4-213s-133.1-88.3-213-88.4C230.7 11.7 154 43.5 97.5 100 40.9 156.5 9.1 233.1 9 313zm133.3 63.1c6.9-33 11.2-66.5 12.9-100.2 2.5-25.3 14.5-48.7 33.6-65.4 19.1-16.8 43.8-25.7 69.2-24.9a123.34 123.34 0 0 1 49.2 7.4c15.7 5.8 30.1 14.7 42.2 26.3 12.1 11.5 21.8 25.4 28.3 40.9 6.6 15.4 9.9 32 9.8 48.7h5.1c5.6-75.7-48.9-138.1-138.4-136.1l-14.9-85.3c209.7-31.1 271.2 105.9 257 197.9-13.5 86.4-66.6 108.2-72.8 169.7-1.5 16.2.9 32.6 6.9 47.8l-1.6 2c-18.1-6.2-34.1-17.5-45.9-32.6s-19-33.2-20.8-52.3c-4-44.4-11.3-56.2-26.7-64.2-22.2-11.5-44.4-7.1-61.1-24.2a73.01 73.01 0 0 1-9.8-39.3c.2-6.1-.9-12.1-3.1-17.8a44.48 44.48 0 0 0-9.9-15.1c-4.3-4.3-9.5-7.6-15.1-9.9-5.7-2.2-11.7-3.3-17.8-3v3.1c5.3.3 10.5 1.6 15.2 3.9 4.8 2.3 9 5.5 12.5 9.5s6.2 8.6 7.8 13.6c1.7 5 2.3 10.3 2 15.6-1.2 13.8.8 27.6 6 40.4 13.3 27.8 52.2 24.4 70.2 36.4 13.1 9.1 15.5 22.2 19.5 54.9 1.3 15.7 6.6 30.9 15.3 44.1s20.5 24 34.5 31.4v2c-26.6-2.8-53.5 1-78.3 11s-46.8 25.9-64.1 46.3h-2c6.9-61.3-6.7-88.8-15.3-101.5 13.5-4.1 26.4-9.8 38.4-17.1l-2-3.6c-47.1 20-88.8 27.5-104.2 18.2-3.6-2.8-6.1-6.8-7.1-11.2-1-4.5-.5-9.1 1.6-13.2.8-2.3.9-4.8.3-7.2-.7-2.4-2.1-4.4-4-5.9 2.4-6.9 20.7-2.9 22.2-2.4v-5.1s-22.2-1.1-26.4-8.7a20.21 20.21 0 0 0 3.6-14.9l-17.5-1.8c-.8-.1-1.6-.4-2.4-.8s-1.3-1-1.8-1.7-.8-1.5-1-2.3-.1-1.7.1-2.5m40.3-32.9c8-5.3 17.5-7.9 27.1-7.6v-2.9l-34.9-9.8c-1.2 3.8-1.2 7.9.3 11.6 1.4 3.7 4.1 6.8 7.5 8.8"
                                  fill-opacity=".04" />
                        </svg>
                    </div>
                    <h1 class="knowlegdebank-header__title-home">{{title}}</h1>
                    <h4 class="knowlegdebank-header__sub-title">{{ manchet }}</h4>

                    <h3 class="knowlegdebank-header__latest-title">{{ this.recentlyAddedTitle }}</h3>

                    <div class="splide knowlegdebank-header__latest-articles" role="group" aria-label="Seneste tilføjede artikler">
                        <div class="splide__track">
                            <ul class="splide__list">

                                <li v-for="(item, index) in latestArticles" :key="index"
                                    class="splide__slide knowlegdebank-header__article">
                                    <a :href="item.url">
                                        <div class="knowlegdebank-header__meta-data">
                                            <div class="knowlegdebank-header__date">
                                                {{ toDate(item.date) }}
                                            </div>
                                            <div class="knowlegdebank-header__type">
                                                {{ item.type }}
                                            </div>
                                        </div>
                                        <div class="knowlegdebank-header__article-title">
                                            {{ item.title }}
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>

                        <ul class="splide__pagination"></ul>

                        <div class="splide__arrows knowlegdebank-header__btn-group">
                            <div>
                                <button class="splide__arrow splide__arrow--prev" aria-label="Previous">
                                    <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.5 16L2 8.5L9.5 1" stroke="white" stroke-width="2" />
                                    </svg>
                                </button>
                                <button class="splide__arrow splide__arrow--next" aria-label="Next">
                                    <svg width="11" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L8.5 8.5L1 16" stroke="white" stroke-width="2" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="cludo-search-results" class="cludo-search-results grid-container">

            <div class="cludo-search-results__layout">
                <div class="cludo-search-results__facets search-filters" aria-controls="search-results"></div>
                <div class="cludo-search-results__results-wrapper">
                    <div class="cludo-search-results__search-result-count search-result-count" role="status">
                    </div>
                    <div class="cludo-search-results__did-you-mean search-did-you-mean"></div>
                    <div class="cludo-search-results__results search-results" role="region" id="search-results" aria-live="polite" aria-label="Search results"></div>
                </div>
            </div>
        </div>

        <div class="grid-container">

            <div class="knowlegdebank-container">
                <div class="knowlegdebank-container__search">
                    <header>
                        <h3>
                            {{ this.searchSection }}
                        </h3>

                        <a v-if="searchHelpLinkUrl" :href="searchHelpLinkUrl" target="_blank" class="search-helplink">{{ searchHelpLinkName }}</a>
                    </header>
                    <form class="knowlegdebank-container__searchForm cludo-relative knowlegdebank-header__search" role="search" id="cludo-search-form-knowledge-bank" :action="searchRequestUrl" method="get">
                        <input class="knowlegdebank-container__input" type="text" name="q" :placeholder="searchPlaceholder" />
                        <button class="knowlegdebank-container__search-btn" type="submit">
                            <span>{{ searchButtonText }}</span>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M29.7595 28.5987L20.8984 19.7376C24.9787 15.056 24.787 7.92377 20.3257 3.47623C18.0775 1.23461 15.0897 0 11.9143 0C8.72442 0 5.72719 1.24398 3.47532 3.50252C1.22866 5.7558 -0.00595064 8.74969 2.1566e-05 11.9333C0.00596801 15.117 1.25085 18.1069 3.50506 20.3523C5.75196 22.5951 8.73853 23.8302 11.9142 23.8302C14.8232 23.8302 17.5698 22.7925 19.7395 20.8969L28.6 29.7574C28.7601 29.9175 28.9699 29.9973 29.1798 29.9973C29.3898 29.9973 29.5993 29.9173 29.7596 29.7574C30.08 29.4377 30.0795 28.9189 29.7595 28.5987ZM4.66222 19.1913C2.71791 17.2553 1.64432 14.6763 1.63905 11.9304C1.63402 9.1849 2.69824 6.60298 4.63593 4.65955C6.57842 2.71179 9.1631 1.63867 11.9138 1.63867C14.6527 1.63867 17.2285 2.70336 19.1677 4.63689C23.1794 8.63622 23.1908 15.1544 19.1929 19.1675C17.2501 21.1164 14.6648 22.1902 11.9138 22.1902C9.1752 22.1909 6.60084 21.1263 4.66222 19.1913Z"
                                      fill="white" />
                            </svg>
                        </button>
                    </form>
                    <div class="cludo-header-search-result-count" role="status"></div>
                    <div id="cludo-search-results" class="cludo-search-results grid-container">

                        <div class="cludo-search-results__layout">
                            <div class="cludo-search-results__facets search-filters" aria-controls="search-results"></div>
                            <div class="cludo-search-results__results-wrapper">
                                <div class="cludo-search-results__search-result-count search-result-count" role="status">
                                </div>
                                <div class="cludo-search-results__did-you-mean search-did-you-mean"></div>
                                <div class="cludo-search-results__results search-results" role="region" id="search-results" aria-live="polite" aria-label="Search results"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Splide from "@splidejs/splide";

export default {
  name: "ArticleViewComponent",
  props: [
    "breadcrumb",
    "bankArticles",
    "recentlyAddedTitle",
    "searchSection",
    "searchRequestUrl",
    "searchPlaceholder",
    "searchButtonText",
    "knowledgeBankTopics",
    "title",
    "manchet",
    "searchHelpLinkName",
    "searchHelpLinkName",
    "searchHelpLinkUrl"
  ],
  data() {
    return {
      error: false,
      loading: false,
      isMobile: false,
      latestArticles: [],
      subTopics: ["Ejendomshandler", "Fejl og pligter"],
    };
  },
  computed: {},
  mounted() {
    this.latestArticles = JSON.parse(this.bankArticles)
  },
  updated() {
    new Splide('.splide', {
      perPage: 3,
      perMove: 1,
      gap: 30,
      speed: 1000,
      pagination: true,
      arrows: true,
      drag: true,
      rewind: true,
      dragMinThreshold: 10,

      breakpoints: {
        900: {
          perPage: 2,
          perMove: 1,
          gap: 25,
          rewind: true,
        },
        640: {
          perPage: 1,
          perMove: 1,
          gap: 18,
          rewind: true,
        }
      }
    }).mount();
  },
  methods: {
    toDate(stamp) {
          let curDate = new Date(stamp).toLocaleString('da-DK', { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          let splitArr = curDate.split(" ");
          let rawMonth = splitArr[2].substring(0, 3);
          const firstLetter = rawMonth.charAt(0).toLowerCase();
          let month = firstLetter + rawMonth.slice(1)
          return `${splitArr[1]} ${month} ${splitArr[3]}`;
    },
  },
};
</script>
